import { Component, Inject, Input, OnInit, OnChanges, SimpleChanges, Self, ViewChild, AfterViewInit, ElementRef, QueryList, ViewChildren } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { DefaultValuesService } from '../../../../services/defaultvalues.service';
import { HttpClient } from '@angular/common/http';
import { Utils } from '../../../../utils/utils';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from '../../../../services/dialog.service';
import { DestroyService } from '../../../../services/destroyservice';
import { takeUntil } from 'rxjs';
import { MatSort } from "@angular/material/sort";
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatDialog } from '@angular/material/dialog';
import { PeripheralSoftwareDetailsDialogComponent } from './peripheralsoftwaredetails-dialog.component';

@Component({
    selector: 'peripheralsoftware',
    templateUrl: './peripheralsoftware.component.html',
    styleUrls: ['../../../../style/new-generic-styles.component.less',
        '../../../../style/tables/table-add-butt-header-orange.less'
        , '../softwarereleases.component.less',
        './peripheralsoftware.component.less'],
    providers: [DestroyService],
    standalone: false
})
export class EMTPeripheralSoftware implements OnInit, AfterViewInit, OnChanges {

    @Input() availableFamilyCodes: FamilyCode[] = [];
    @Input() availableLanguages: Language[] = [];
    @Input() isContractSpecific: boolean = false;
    @Input() boardFilter: string = '';
    @Input() familyCodeFilter: string = '';

    @ViewChild(MatTable) objTable!: MatTable<any>;
    @ViewChild(MatSort) sort!: MatSort;
    @ViewChildren('compatibilityInputRef') compatibilityInputRefs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren(MatAutocompleteTrigger) autocompleteTriggers!: QueryList<MatAutocompleteTrigger>;

    public dataSource = new MatTableDataSource<any>();
    PSForm!: FormGroup;
    genType: number = 0;
    originalPeripheralSoftware: EMTPeripheralSoftwareItem[] = [];
    modifiedPeripheralSoftware: EMTPeripheralSoftwareItem[] = [];
    newPeripheralSoftware: EMTPeripheralSoftwareItem[] = [];
    isCallSucceed: number = 0;
    subscriptionStage: any;
    forbiddenchars = ['/', '\\', ':', '*', '?', '<', '>', '|', '"'];

    compatibilityGroups: EMTGlobalControllerGroup[] = [];
    compatibilityInput: string[] = [];
    compatibilityGroupsFiltered: EMTGlobalControllerGroup[][] = [];
    separatorKeysCodes: number[] = [ENTER, COMMA];

    availableFunctionTypes: ComponentFunction[] = [];
    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        private _formBuilder: FormBuilder,
        public defaults: DefaultValuesService,
        public datePipe: DatePipe,
        private toastrService: ToastrService,
        private confimDialog: DialogService,
        @Self() private readonly destroy$: DestroyService,
        private dialogForm: MatDialog) {
        this.confimDialog.tthis = this;
    }

    columnsToDisplay = ["peripheralSoftwareVersion", "familycode", "releaseDate", "comment", "compatibility", "action"];

    ngOnInit(): void {
        this.subscriptionStage = this.defaults.stageMessageChanges$.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.getGlobalControllerGroups(() => {
                this.getPeripheralSoftwareVersions();
            })
        });

        this.genType = 0;
        this.PSForm = this._formBuilder.group({
            PSRows: this._formBuilder.array([])
        });
        this.getFunctionTypes();
        this.getGlobalControllerGroups(() => {
            this.getPeripheralSoftwareVersions();
        });
    }

    ngAfterViewInit() {
        this.dataSource.sortData = (data, sort) => {
            if (!sort.active || sort.direction === '') {
                return data;
            }
            return data.slice().sort((a, b) => {
                const isAsc = sort.direction === 'asc';
                switch (sort.active) {
                    case 'familycode':
                        const labelA = this.getFamilyCodeText(a.familyCodeId || -1) || '';
                        const labelB = this.getFamilyCodeText(b.familyCodeId || -1) || '';
                        return labelA.localeCompare(labelB) * (isAsc ? 1 : -1);
                    case 'peripheralSoftwareVersion':
                        return (a.peripheralSoftwareVersion || '').localeCompare(b.peripheralSoftwareVersion || '') * (isAsc ? 1 : -1);
                    case 'softwareFileName':
                        return (a.softwareFileName || '').localeCompare(b.softwareFileName || '') * (isAsc ? 1 : -1);
                    case 'releaseDate':
                        return ((a.releaseDate ? new Date(a.releaseDate).getTime() : 0) - (b.releaseDate ? new Date(b.releaseDate).getTime() : 0)) * (isAsc ? 1 : -1);
                    case 'comment':
                        return (a.comment || '').localeCompare(b.comment || '') * (isAsc ? 1 : -1);
                    case 'compatibility':
                        const getFirstName = (item: any): string => {
                            if (!item.compatibilities || item.compatibilities.length === 0) {
                                return '';
                            }
                            const sorted = [...item.compatibilities].sort((a, b) =>
                                a.globalControllerGroupName.localeCompare(b.globalControllerGroupName)
                            );
                            return sorted[0].globalControllerGroupName || '';
                        };

                        return getFirstName(a).localeCompare(getFirstName(b)) * (isAsc ? 1 : -1);
                    default:
                        return 0;
                }
            });
        };
        this.dataSource.sort = this.sort;
        this.dataSource.filterPredicate = (data: any): boolean => this.matchesFilters(data);
    }

    getFunctionTypes() {
        Utils.httpGetComponentFunctionTypes(
            this.http,
            this.baseUrl,
            this,
            (tthis: EMTPeripheralSoftware, result: ComponentFunctionTypes) => {
                tthis.availableFunctionTypes = result?.typeList ?? [];
            }
        );
    }

    getFamilyCodeName(familyCodeId: number): string {
        const famcode = this.availableFamilyCodes?.find(x => x.familyCodeId === familyCodeId);
        if (!famcode) {
            return '';
        }
        return `${famcode.familyCode} - ${famcode.familyCodeName}`;
    }

    getBoardName(familyCodeId: number): string {
        const famcode = this.availableFamilyCodes?.find(x => x.familyCodeId === familyCodeId);
        if (!famcode) {
            return '';
        }
        const funcType = this.availableFunctionTypes?.find(t => t.functionTypeId === famcode.functionTypeId);
        return funcType?.functionTypeName ?? '';
    }

    matchesFilters(element: any): boolean {
        const board = this.boardFilter?.trim().toLowerCase() ?? '';
        const family = this.familyCodeFilter?.trim().toLowerCase() ?? '';
        const boardMatch = !board || this.getBoardName(element.familyCodeId).toLowerCase().includes(board);
        const familyMatch = !family || this.getFamilyCodeName(element.familyCodeId).toLowerCase().includes(family);
        return boardMatch && familyMatch;
    }

    applyPeripheralFilters() {
        const hasFilter = !!(this.boardFilter?.trim() || this.familyCodeFilter?.trim());
        this.dataSource.filter = hasFilter ? `${this.boardFilter}|${this.familyCodeFilter}`.toLowerCase() : '';
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['boardFilter'] || changes['familyCodeFilter']) {
            this.applyPeripheralFilters();
        }
    }

    getPeripheralSoftwareVersions() {
        Utils.httpGetEMTPeripheralSoftwareVersions(
            this.http,
            this.baseUrl,
            this.isContractSpecific,
            this,
            function (tthis: EMTPeripheralSoftware, result: EMTPeripheralSoftwareVersions) {
                tthis.originalPeripheralSoftware = result.versionList;
                tthis.mapDataToForm(tthis.originalPeripheralSoftware);
            }
        );

    }

    getGlobalControllerGroups(callback?: () => void) {
        Utils.httpGetEMTGlobalControllerGroups(
            this.http,
            this.baseUrl,
            this,
            (tthis: EMTPeripheralSoftware, result: EMTGlobalControllerGroup[]) => {
                tthis.compatibilityGroups = result;
                if (callback) callback();
            }
        );
    }

    mapDataToForm(data) {
        this.PSForm = this._formBuilder.group({
            PSRows: this._formBuilder.array([])
        });
        this.PSForm = this._formBuilder.group({
            PSRows: this._formBuilder.array(data.map((val, index) => this._formBuilder.group({
                peripheralSoftwareVersionID: new FormControl(val.peripheralSoftwareVersionID),
                peripheralSoftwareVersion: new FormControl(val.peripheralSoftwareVersion),
                familyCodeId: new FormControl(val.familyCodeId ?? -1),
                releaseDate: new FormControl(val.releaseDate != null ? new Date(val.releaseDate) : ""),
                softwareFileName: new FormControl(val.softwareFileName),
                softwareFile: new FormControl(val.softwareFile ?? null),
                comment: new FormControl(val.comment),
                isEditable: new FormControl(true),
                isNewRow: new FormControl(false),
                action: new FormControl('existingRecord'),
                isOpenOverlay: new FormControl(false),
                textAreaId: new FormControl(this.getTextAreaId(index)),
                maxCommentLength: new FormControl(2000),
                modifUser: new FormControl(val.modifUser),
                availableReleaseNotes: this._formBuilder.array(
                    (val.releaseNotes ?? []).map(note =>
                        this._formBuilder.group({
                            softwareReleaseNotesId: new FormControl(note.softwareReleaseNotesId),
                            softwareReleaseId: new FormControl(note.softwareReleaseId),
                            language: new FormControl(note.language),
                            fileName: new FormControl(note.fileName),
                            isEnabled: new FormControl(note.isEnabled),
                            createdByUser: new FormControl(note.createdByUser),
                            changedAtUtc: new FormControl(note.changedAtUtc),
                            changedByUser: new FormControl(note.changedByUser),
                            createdAtUtc: new FormControl(note.createdAtUtc)
                        })
                    )
                ),
                compatibilities: new FormControl(
                    (val.compatibilities ?? []).map((id: number) =>
                        this.compatibilityGroups.find(g => g.globalControllerGroupId === id)
                    ).filter(Boolean)
                ),
            })
            )) //end of fb array
        }); // end of form group cretation
        this.dataSource.data = (this.PSForm.get('PSRows') as FormArray).value;
        this.dataSource.sort = this.sort;
        this.compatibilityInput = this.dataSource.data.map(() => '');
        this.compatibilityGroupsFiltered = this.dataSource.data.map(() => this.compatibilityGroups.slice());
        //this.compatibilityInput.forEach((element, i) => this.filterCompatibilityOptions('', element));

    }

    getIndexByID(id: number): number {
        const arr = this.PSForm.get('PSRows') as FormArray;
        return arr.value.findIndex((row: any) => row.peripheralSoftwareVersionID === id);
    }

    initPSForm(index: number): FormGroup {
        return this._formBuilder.group({
            peripheralSoftwareVersionID: new FormControl(-1),
            peripheralSoftwareVersion: new FormControl(`0.0.${this.genType}`),
            familyCodeId: new FormControl(-1),
            releaseDate: new FormControl(),
            softwareFileName: new FormControl(''),
            comment: new FormControl(''),
            action: new FormControl('newRecord'),
            isEditable: new FormControl(false),
            isNewRow: new FormControl(true),
            softwareFile: new FormControl(null),
            isOpenOverlay: new FormControl(false),
            textAreaId: new FormControl(this.getTextAreaId(index)),
            maxCommentLength: new FormControl(2000),
            compatibility: new FormControl([]),
            modifUser: new FormControl(''),
        });
    }

    editRowByID(id: number) {
        const arr = this.PSForm.get('PSRows') as FormArray;
        const idx = this.getIndexByID(id);
        if (idx !== -1) {
            arr.at(idx).get('isEditable')?.setValue(false);
            this.dataSource.data = arr.value;
        }
    }

    addNewRow() {
        const tempFormGroup = this.initPSForm(0);
        this.showDetails(tempFormGroup, null);
    }

    getFileUploadId(index) {
        return `psfu_${index}`;
    }

    getFamilyCodeText(familyCodeId: number) {
        let famcode = this.availableFamilyCodes?.find(x => x.familyCodeId === familyCodeId);
        if (famcode)
            return `${famcode.familyCode} - ${famcode.familyCodeName}`;
        else
            return "---";
    }

    resetRowByID(id: number, element: EMTPeripheralSoftwareItem) {
        const arr = this.PSForm.get('PSRows') as FormArray;
        const idx = this.getIndexByID(id);
        if (idx !== -1) {
            const isNewRow = arr.at(idx).get('isNewRow')?.value;
            if (isNewRow) {
                arr.removeAt(idx);
            } else {
                const original = this.originalPeripheralSoftware.find(
                    s => s.peripheralSoftwareVersionID === id
                );
                if (original) {
                    arr.at(idx).patchValue({
                        peripheralSoftwareVersion: original.peripheralSoftwareVersion,
                        familyCodeId: original.familyCodeId ?? -1,
                        releaseDate: original.releaseDate != null ? new Date(original.releaseDate) : "",
                        softwareFileName: original.softwareFileName,
                        softwareFile: original.softwareFile ?? null,
                        comment: original.comment,
                        compatibilities: (original.compatibilities ?? []).map((id: number) =>
                            this.compatibilityGroups.find(g => g.globalControllerGroupId === id)
                        ).filter(Boolean),
                    });
                }
                arr.at(idx).get('isEditable')?.setValue(true);
                this.compatibilityInput[idx] = '';
                this.filterCompatibilityOptions('', element);
                setTimeout(() => {
                    const inputRef = this.compatibilityInputRefs?.toArray()[idx];
                    if (inputRef) {
                        inputRef.nativeElement.value = '';
                    }
                });
            }
            this.dataSource.data = arr.value;
        }
    }

    refreshTable() {
        this.objTable.renderRows();
    }

    onSave() {
        if (this.anyChange()) {

            const mapCompatibilityIds = (arr: any[]) =>
                arr.map(row => ({
                    ...row,
                    compatibilities: (row.compatibilities || []).map((c: any) => c.globalControllerGroupId)
                }));
            const modified = mapCompatibilityIds(this.modifiedPeripheralSoftware);
            const added = mapCompatibilityIds(this.newPeripheralSoftware);

            let formData: FormData = new FormData();
            modified.forEach((val) => {
                formData.append(val.fileUploadId, val.softwareFile);
            });
            added.forEach((val) => {
                formData.append(val.fileUploadId, val.softwareFile);
            });
            let versionChanges = { 'modifiedVersions': modified, 'newVersions': added }
            formData.append('versionChanges', JSON.stringify(versionChanges));

            Utils.httpUpdatePeripheralSoftwareVersions(
                this.http
                , this.baseUrl
                , formData
                , this
                , function (tthis: EMTPeripheralSoftware, result: any) {
                    if (result?.error && result.errorMssg) {
                        tthis.confimDialog.showErrorDialog({
                            'error':
                            {
                                'message': result.errorMssg
                            }
                        })
                    }
                    tthis.getPeripheralSoftwareVersions();
                    tthis.funcNotify();
                }
            )
        }
    }

    // compatibility management
    filterCompatibilityOptions(input: string, element: EMTPeripheralSoftwareItem) {
        const current = element.compatibilities || [];
        this.compatibilityGroupsFiltered[element.peripheralSoftwareVersionID] = this.compatibilityGroups.filter(
            opt =>
                opt.globalControllerGroupName.toLowerCase().includes(String(input || '').toLowerCase()) &&
                !current.some((c: any) => c.globalControllerGroupId === opt.globalControllerGroupId)
        );
    }

    selectedCompatibility(event: MatAutocompleteSelectedEvent, element: EMTPeripheralSoftwareItem) {
        const selectedId = event.option.value;
        const selected = this.compatibilityGroups.find(g => g.globalControllerGroupId === selectedId);
        if (selected && !element.compatibilities.some((c: any) => c.globalControllerGroupId === selected.globalControllerGroupId)) {
            element.compatibilities.push(selected);
        }
        this.compatibilityInput[element.peripheralSoftwareVersionID] = '';
        this.filterCompatibilityOptions('', element);
        setTimeout(() => {
            const inputRef = this.compatibilityInputRefs?.toArray()[element.peripheralSoftwareVersionID];
            if (inputRef) {
                inputRef.nativeElement.value = '';
            }
        });
    }

    addCompatibilityFromInput(event: any, element: EMTPeripheralSoftwareItem) {
        const input = event.input;
        const value = event.value?.trim();
        if (value) {
            const found = this.compatibilityGroups.find(
                g => g.globalControllerGroupName.toLowerCase() === value.toLowerCase()
            );
            if (found && !element.compatibilities.some((c: any) => c.globalControllerGroupId === found.globalControllerGroupId)) {
                element.compatibilities.push(found);
            }
        }
        this.compatibilityInput[element.peripheralSoftwareVersionID] = '';
        this.filterCompatibilityOptions('', element);
        setTimeout(() => {
            const inputRef = this.compatibilityInputRefs?.toArray()[element.peripheralSoftwareVersionID];
            if (inputRef) {
                inputRef.nativeElement.value = '';
            }
        });
        if (input) input.value = '';
    }

    removeCompatibility(element: EMTPeripheralSoftwareItem, j: number) {
        element.compatibilities.splice(j, 1);
        this.filterCompatibilityOptions(this.compatibilityInput[element.peripheralSoftwareVersionID], element);
    }

    openAutocomplete(element: EMTPeripheralSoftwareItem) {
        if (!this.compatibilityInput[element.peripheralSoftwareVersionID] || this.compatibilityInput[element.peripheralSoftwareVersionID].trim() === '') {
            this.filterCompatibilityOptions(this.compatibilityInput[element.peripheralSoftwareVersionID], element);
        }
        setTimeout(() => {
            const trigger = this.autocompleteTriggers?.toArray()[element.peripheralSoftwareVersionID];
            if (trigger && this.compatibilityGroupsFiltered[element.peripheralSoftwareVersionID]?.length > 0) {
                trigger.openPanel();
            }
        });
    }

    anyChange() {
        this.mapFormToData();
        return this.modifiedPeripheralSoftware?.length > 0 || this.newPeripheralSoftware?.length > 0;
    }

    mapFormToData() {
        this.modifiedPeripheralSoftware = this.PSForm.get('PSRows')?.value.filter(row => !row.isNewRow
            && !row.isEditable
            && row.familyCodeId !== -1
            && row.peripheralSoftwareVersion !== "" && row.peripheralSoftwareVersion.length <= 50
            && (row.comment != null ? row.comment.length <= 2000 : true)
        );
        this.newPeripheralSoftware = this.PSForm.get('PSRows')?.value.filter(row => row.isNewRow
            && row.familyCodeId !== -1
            && row.peripheralSoftwareVersion !== "" && row.peripheralSoftwareVersion.length <= 50
            && (row.comment != null ? row.comment.length <= 2000 : true)
            && row.softwareFile != null
        );
    }

    funcNotify() {
        if (this.isCallSucceed === 1) {
            this.toastrService.success('Save request successfully sent!');
        }
        else if (this.isCallSucceed === -1) {
            this.toastrService.error('Save action could not be performed. Please, contact with administrator');
        }
    }

    checkInput(event) {
        if (this.forbiddenchars.some(x => x === event.key))
            event.preventDefault();
    }

    getDateUTCChange(element, event) {
        let utcDate = Utils.dateUTCchange(event);
        element.releaseDate = utcDate;
    }

    getTextAreaId(index) {
        return `tArea_${index}`;
    }

    toggleOvl(index) {
        this.PSForm.value.PSRows[index].isOpenOverlay = !this.PSForm.value.PSRows[index].isOpenOverlay;
    }

    fitTextAreaToContent(index) {
        setTimeout(() => {
            let element = document.getElementById(this.getTextAreaId(index));
            if (element) {
                element.style.height = "";
                element.style.height = element.scrollHeight + 3 + "px";
                element.focus();
                if (this.PSForm.value.PSRows[index].isEditable)
                    element.setAttribute("readonly", "");
                else
                    element.removeAttribute("readonly");
            }
        }, 25);
    }

    onCommentChange(value: string, element: any) {
        element.comment = value;
    }

    get psRows(): FormArray {
        return this.PSForm.get('PSRows') as FormArray;
    }

    getPSRowFormGroup(id: number): FormGroup | any {
        const index = this.psRows.controls.findIndex(
            (group: any) => group.get('peripheralSoftwareVersionID')?.value === id
        );
        return index !== -1 ? this.psRows.at(index) as FormGroup : null;
    }

    showDetails(formGroup: FormGroup, i: number | null): void {
        const dialogRef = this.dialogForm.open(PeripheralSoftwareDetailsDialogComponent, {
            height: 'auto',
            width: '950px',
            data: {
                softwareReleaseForm: formGroup,
                availableFamilyCodes: this.availableFamilyCodes,
                fileUploadId: this.getFileUploadId(i ?? 0),
                availableLanguages: this.availableLanguages,
                isContractSpecific: this.isContractSpecific
            },
            panelClass: 'details-dialog-panel',
            disableClose: true,
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result?.errorMssg) {
                this.confimDialog.showErrorDialog({
                    'error':
                    {
                        'message': result.errorMssg
                    }
                });
            }
            if (result) {
                if (result.canceled) {
                    if (result.updatedReleaseNotes && result.updatedReleaseNotes.length > 0) {
                        const releaseNotesArray = new FormArray(
                            result.updatedReleaseNotes.map(note =>
                                this._formBuilder.group({
                                    softwareReleaseNotesId: [note.softwareReleaseNotesId],
                                    softwareReleaseId: [note.softwareReleaseId],
                                    language: [note.language],
                                    fileName: [note.fileName],
                                    isEnabled: [note.isEnabled],
                                    createdByUser: [note.createdByUser],
                                    createdAtUtc: [note.createdAtUtc],
                                    changedAtUtc: [note.changedAtUtc],
                                    changedByUser: [note.changedByUser],
                                    file: [null]
                                })
                            )
                        );

                        // Replace the old FormArray with the new one so the UI refreshes
                        const rowFormGroup = this.getPSRowFormGroup(i ?? 0);
                        rowFormGroup.setControl('availableReleaseNotes', releaseNotesArray);
                        rowFormGroup.updateValueAndValidity();
                    }
                }
                else {
                    if (result.success) {
                        this.isCallSucceed = 1;
                    } else {
                        this.isCallSucceed = -1;
                    }
                    this.funcNotify();
                    this.getPeripheralSoftwareVersions();
                }
            }
        });
    }
}
